export enum SoundEvent {
    default_button_press = "default_button_press",
    button_press_NAME = "button_press_{0}",
    start_freespin = "start_freespin",
    start_spin = "start_spin",
    end_freespin = "end_freespin",
    end_spin = "end_spin",
    big_win_countup_start = "big_win_countup_start",
    big_win_countup_end = "big_win_countup_end",
    tickup_totalwin_start = "tickup_totalwin_start",
    tickup_linewin_start = "tickup_linewin_start",
    tickup_anywin_start = "tickup_anywin_start",
    tickup_anywin_end = "tickup_anywin_end",
    reel_transition_start = "reel_transition_start",
    reel_transition_end = "reel_transition_end",
    reel_transition_anticipate = "reel_transition_anticipate",
    reel_transition_skip = "reel_transition_skip",
    reel_transition_skip_end = "reel_transition_skip_end",
    sounds_ready = "sounds_ready",
    symbol_ID_highlight = "symbol_{0}_highlight",
    symbol_ID_MATCHES_highlight = "symbol_{0}_{1}_highlight",
    symbol_ID_win = "symbol_{0}_win",
    symbol_any_win = "symbol_any_win",
    symbol_win_below_threshold = "symbol_win_below_threshold", 
    symbol_ID_win_CYCLE = "symbol_{0}_win_{1}",
    symbol_any_win_CYCLE = "symbol_any_win_{0}",
    symbol_ID_MATCHES_win = "symbol_{0}_{1}_win",
    symbol_any_MATCHES_win = "symbol_any_{0}_win",
    symbol_ID_win_MATCHES_CYCLE = "symbol_{0}_win_{1}_{2}",
    symbol_any_win_MATCHES_CYCLE = "symbol_any_win_{0}_{1}",
    symbol_ID_celebrate = "symbol_{0}_celebrate",
    symbol_any_celebrate = "symbol_any_celebrate",
    symbol_ID_land = "symbol_{0}_land",
    symbol_any_land = "symbol_any_land",
    symbol_ID_expand = "symbol_{0}_expand",
    symbol_any_expand = "symbol_any_expand",
    symbol_ID_expand_up = "symbol_{0}_expand_up",
    symbol_any_expand_up = "symbol_any_expand_up",
    symbol_ID_expand_down = "symbol_{0}_expand_down",
    symbol_any_expand_down = "symbol_any_expand_down",
    reel_N_spin_start = "reel_{0}_spin_start",
    reel_any_spin_start = "reel_any_spin_start",
    reel_N_spin_end = "reel_{0}_spin_end",
    reel_any_spin_end = "reel_any_spin_end",
    reel_N_skip_start = "reel_{0}_skip_start",
    reel_any_skip_start = "reel_any_skip_start",
    reel_N_skip_end = "reel_{0}_skip_end",
    reel_any_skip_end = "reel_any_skip_end",
    reel_N_anticipate_start = "reel_{0}_anticipate_start",
    reel_any_anticipate_start = "reel_any_anticipate_start",
    reel_N_anticipate_end = "reel_{0}_anticipate_end",
    reel_any_anticipate_end = "reel_any_anticipate_end",
    spinner_stage_complete = "spinner_stage_complete_{0}",
    preload_complete = "preload_complete",
    prompt_countup_start = "prompt_countup_start",
    prompt_countup_start_SCENE = "prompt_countup_start_{0}",
    prompt_countup_end = "prompt_countup_end",
    prompt_countup_end_SCENE = "prompt_countup_end_{0}",
    sound_prompt_yes_press = "sound_prompt_yes_press",
    toggle_on_press = "toggle_on_press",
    toggle_off_press = "toggle_off_press",
    enter_scene_LAYER_SCENE = "enter_scene_{0}_{1}",
    exit_scene_LAYER_SCENE = "exit_scene_{0}_{1}",
    enter_state_STATE = "enter_state_{0}",
    exit_state_STATE = "exit_state_{0}",
    highlight_all_wins = "highlight_all_wins",
    bonus_ID_land = "bonus_{0}_land",
    bonus_ID_land_COUNT = "bonus_{0}_land_{1}",
    bonus_SYMBOL_land = "bonus_{0}_land",
    bonus_SYMBOL_land_COUNT = "bonus_{0}_land_{1}",
    skip_expands = "skip_expands",
    stick_symbol = "stick_symbol",
    stick_symbol_ID = "stick_symbol_{0}",
    prompt_continue_press = "prompt_continue_press",
    winnings_countup = "winnings_countup",
    winnings_countup_end = "winnings_countup_end"
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/sound/sound-events.ts